import { LuuDoFilePX } from './../quy-trinh-san-xuat-page-model/quy-trinh-san-xuat-page.model';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../../environments/environment";
import { HttpUtilsService } from "../../../../../../core/_base/crud/utils/http-utils.service";
import { QueryParamsModel } from "../../../../../../core/_base/crud";
import { QuyTrinhSanXuatPage } from "../quy-trinh-san-xuat-page-model/quy-trinh-san-xuat-page.model";
const API_ROOT_URL = environment.ApiRoot + "/qtsx";

@Injectable()
export class QuyTrinhSanXuatPageService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(
		new QueryParamsModel({}, "asc", "", 0, 10)
	);
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(
		new QueryParamsModel({}, "asc", "", 0, 10)
	);
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(
		private http: HttpClient,
		private httpUtils: HttpUtilsService
	) {}

	getData(queryParams: QueryParamsModel): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<QuyTrinhSanXuatPage>(API_ROOT_URL + "/QTSX_LIST", {
			headers: httpHeaders,
			params: httpParams,
		});
	}

	insert(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + "/THEM_MOI_QTSX", item, {
			headers: httpHeaders,
		});
	}

	edit(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QuyTrinhSanXuatPage>(
			API_ROOT_URL + "/THEM_MOI_QTSX",
			item,
			{ headers: httpHeaders }
		);
	}

	detail(Id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", Id.toString());
		return this.http.get<QuyTrinhSanXuatPage>(
			API_ROOT_URL + `/QTSX_DETAIL`,
			{ headers: httpHeaders, params: params }
		);
	}

	delete(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<QuyTrinhSanXuatPage>(
			API_ROOT_URL + `/QTSX_DELETE`,
			{ headers: httpHeaders, params: params }
		);
	}

	cancel(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<QuyTrinhSanXuatPage>(
			API_ROOT_URL + `/QTSX_CANCEL`,
			{ headers: httpHeaders, params: params }
		);
	}

	confirm(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + `/QTSX_ACCEPT`, item, {
			headers: httpHeaders,
		});
	}

	lite(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/YeuCauBaoGia_Lite`, {
			headers: httpHeaders,
		});
	}

	liteId(id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", id.toString());
		return this.http.get<any>(API_ROOT_URL + `/YeuCauBaoGia_LiteId`, {
			headers: httpHeaders,
			params: params,
		});
	}

	dropdown(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/QTSX_Lite`, {
			headers: httpHeaders,
		});
	}

	DanhSachHangHoa(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/DanhSachHangHoa`, {
			headers: httpHeaders,
		});
	}

	listYCNCLite(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/YCNC_LIST_LITE`, {
			headers: httpHeaders,
		});
	}

	listBTPQTSXLite(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/BTP_QTSX_LIST_LITE`, {
			headers: httpHeaders,
		});
	}


	listTPQTSXLite(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/TP_QTSX_LIST_LITE`, {
			headers: httpHeaders,
		});
	}

	listMMTBLite(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/MMTB_LIST_LITE`, {
			headers: httpHeaders,
		});
	}

	exists_idhh(idhh: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("IdHH", idhh.toString());
		return this.http.get<any>(API_ROOT_URL + `/QTSX_IS_EXISTS_IDHH`, {
			headers: httpHeaders,
			params: params,
		});
	}

	getSPEC(Id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("IdHH", Id.toString());
		return this.http.get<QuyTrinhSanXuatPage>(
			API_ROOT_URL + `/Spec_DanhSach_TheoHH`,
			{ headers: httpHeaders, params: params }
		);
	}

	getKiemTraHangHoa(Id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("IdHH", Id.toString());
		return this.http.get<QuyTrinhSanXuatPage>(
			API_ROOT_URL + `/KTHH_DanhSach_TheoHH`,
			{ headers: httpHeaders, params: params }
		);
	}

	banGiao(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + `/QTSX_BANGIAO`, item, {
			headers: httpHeaders,
		});
	}

	xacNhanBanGiao(Id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", Id.toString());
		return this.http.get<any>(API_ROOT_URL + `/QTSX_XACNHAN_BANGIAO`, {
			headers: httpHeaders,
			params: params,
		});
	}

	downloadFileAPI(
		IdQTSX: number,
		IdAttachment: number,
		ImageNL: number
	): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams()
			.set("IdQTSX", IdQTSX.toString())
			.set("IdAttachment", IdAttachment.toString())
			.set("ImageNL", ImageNL.toString());
		return this.http.get<Blob>(API_ROOT_URL + "/DownLoadFile", {
			headers: httpHeaders,
			params: httpParams,
			responseType: "blob" as "json",
		});
	}

	removeFile(
		IdQTSX: number,
		IdAttachment: number,
		ImageNL: number
	): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams()
			.set("IdQTSX", IdQTSX.toString())
			.set("IdAttachment", IdAttachment.toString())
			.set("ImageNL", ImageNL.toString());
		return this.http.get<any>(API_ROOT_URL + `/RemoveFile`, {
			headers: httpHeaders,
			params: httpParams,
		});
	}

	uploadFileServe(data: LuuDoFilePX): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + `/FlowChart_Upload`, data, {
			headers: httpHeaders,
		});
	}
}
